module.exports = "https://deal-img.imgix.net/consumer/modern/default-product.4e3103a8.png";